import React from 'react';

import Tab from './tab/tab';

import './tabs.scss';

interface TabsProps {
  className?: string;
}

function Tabs(props: React.PropsWithChildren<TabsProps>) {
  const { className = '', children } = props;

  return (
    <div className={`tabs ${className}`} role="tablist" styleName="container">
      {children}
    </div>
  );
}

export { Tab };
export default Tabs;
